<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>

<div class="card-container">
  <mat-card appearance="outlined" *ngIf="!isLoading && (!dynamicContent || pageError)" class="full">
    <p>{{ 'general.no-data'|translate }}</p>
    <mat-card-content *ngIf="pageError">
      <p>Error: {{ pageError }}</p>
    </mat-card-content>
  </mat-card>
  <ng-container *ngIf="!isLoading">
    <h2>
      {{ dynamicContent.title }}
      <div class="right">
        <button *ngIf="type === 'gastronomy-checkout' && gastroOrders?.length" (click)="downloadXLS()" class="ibexfusion-raised-button" mat-button>
          {{ 'dynamicContent.downloadExcel' | translate }}
        </button>
        <button *ngIf="type === 'gastronomy' && gastroOrders?.length && gastroOrdersByMenuKeys?.length && gastroOrdersByMenuKeys && gastroOrdersByMenuKeys.length" (click)="downloadXLS()" class="ibexfusion-raised-button" mat-button>
          {{ 'dynamicContent.downloadExcel' | translate }}
        </button>
        <button *ngIf="type === 'voucher' && voucherProfiles?.length" (click)="downloadXLS()" class="ibexfusion-raised-button" mat-button>
          {{ 'dynamicContent.downloadExcel' | translate }}
        </button>
        <button *ngIf="type === 'feedback1'" (click)="downloadFile()">
          {{ 'dynamicContent.downloadExcel' | translate }}
        </button>
        <dynamic-content-table-active-state [item]="{ data: dynamicContent }"></dynamic-content-table-active-state>
      </div>
    </h2>
    <div *ngIf="type === 'feedback'">
      <mat-tab-group (selectedTabChange)="tabChanged($event)">
        <mat-tab label="Antworten nach Frage">
          <div class="tab-content" *ngIf="answersByQuestionKey && answersByQuestionKey.length">
            <mat-accordion>
              <mat-expansion-panel *ngFor="let id of answersByQuestionKey">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ questions[id]?.title }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="questions[id]?.type === 'text' || questions[id]?.type === 'textArea' ||
                        questions[id]?.type === 'email'">
                  <ng-container *ngFor="let answer of answersByQuestion[id]; let i = index">
                    <p *ngIf="i < 10">
                      {{ answer[0] }}
                    </p>
                  </ng-container>

                </div>
                <div *ngIf="questions[id]?.type === 'singleChoice' || questions[id]?.type === 'multipleChoice'">
                  <pie-chart [page]="'feedback'" [data]="{answers: questions[id].answers, data: answersByQuestion[id]}"
                             [id]="id"></pie-chart>
                </div>
                <div *ngIf="questions[id]?.type === 'scale'">
                  <column-chart [page]="'feedback'" [data]="{scaleMin: questions[id].scaleMin, scaleMax: questions[id].scaleMax,
                     scaleStep: questions[id].scaleStep, data: answersByQuestion[id]}"
                                [id]="id"></column-chart>
                </div>
              </mat-expansion-panel>
            </mat-accordion>

          </div>
        </mat-tab>
        <mat-tab label="Antworten nach Einsendung">
          <div class="tab-content" *ngIf="answersByQuestionnaire && answersByQuestionnaire.length">
            <mat-accordion>
              <ng-container *ngFor="let answer of answersByQuestionnaire; let ai = index">
                <mat-expansion-panel *ngIf="ai < 10">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <span *ngIf="!findEmail(answer)">{{ answer[0]?.created | date: 'dd.MM.yyyy - HH:mm' }}</span>
                      <span *ngIf="findEmail(answer)">{{ findEmail(answer) }}</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div *ngFor="let ans of answer; let i = index">
                    <div class="question">{{ i + 1 }}. {{ questions[ans.questionId]?.title }}</div>
                    <div class="answer">{{ ans?.answer }}</div>
                  </div>
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div *ngIf="type === 'gastronomy' && gastroOrders?.length && gastroOrdersByMenuKeys?.length">
      <div *ngIf="gastroOrdersByMenuKeys && gastroOrdersByMenuKeys.length" class="gastro-order">
        <div *ngFor="let menuKey of gastroOrdersByMenuKeys">
          <br>
          <h2>{{ menuKey }}: {{ gastroOrdersByMenu[menuKey].length }}</h2>
          <div *ngFor="let order of gastroOrdersByMenu[menuKey]" class="user-order">
            <span>{{ order.firstName }} {{ order.lastName }}</span>{{ order.orderTime | date:'HH:mm' }} Uhr
          </div>
        </div>
      </div>
    </div>
    <div class="gastro-checkout">
      <div class="data">
        <ng-container *ngFor="let gastroType of gastroOrderTypes">
          <div *ngIf="gastroOrdersByType[gastroType]">
            <h3>{{ 'system.dynamicContent.gastroCheckout.' + gastroType + 'Title' | translate }}</h3>
            <div *ngFor="let order of gastroOrdersByType[gastroType]">
              {{ order.firstName }} {{ order.lastName }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="type === 'voucher' && voucherProfiles?.length" class="voucher-detail">
      <div class="voucher-header">
        <h2>Eingelöste Gutscheine</h2>
        <div class="download-button">
          <button (click)="downloadXLS()" class="ibexfusion-raised-button" mat-button>
            <i class="material-icons">get_app</i> {{ 'dynamicContent.downloadExcel' | translate }}
          </button>
        </div>
      </div>
      <div class="voucher-table">
        <div class="voucher-table-header voucher-row">
          <div class="voucher-cell">{{ 'system.dynamicContent.voucher.nameTitle' | translate }}</div>
          <!--<div class="voucher-cell">{{'system.dynamicContent.voucher.rememberedTitle' | translate}}</div>-->
          <div class="voucher-cell">{{ 'system.dynamicContent.voucher.redeemedTitle' | translate }}</div>
        </div>
        <div *ngFor="let profile of voucherProfiles; let i = index" class="voucher-row" [ngClass]="{ shade: i % 2 === 0 }">
          <div class="voucher-cell">{{ profile.firstName }} {{ profile.lastName }}</div>
          <!--<div class="voucher-cell"><ng-container *ngIf="profile.remembered">{{profile.remembered | date:'dd.MM.YYYY - HH:mm'}} Uhr</ng-container></div>-->
          <div class="voucher-cell">
            <ng-container *ngIf="profile.redeemed">{{ profile.redeemed | date:'dd.MM.YYYY - HH:mm' }} Uhr</ng-container>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="type === 'voting'">
      <div><span class="font-xl">{{ 'dynamicContent.type' | translate }}
        :</span> {{ 'dynamicContent.' + dynamicContent.content.type | translate }}</div>
      <ng-container *ngIf="dynamicContent.content.type === 'multipleChoice' || dynamicContent.content.type === 'singleChoice'">
        <div class="font-xl">{{ 'dynamicContent.answers' | translate }}:</div>
        <div *ngFor="let answer of dynamicContent.content.answers" class="answer"> - {{ answer }}</div>
      </ng-container>
      <ng-container *ngIf="dynamicContent.content.type === 'scale'">
        <div>
          <span class="font-xl">{{ 'dynamicContent.scaleIcon' | translate }}</span>
          : {{ 'dynamicContent.' + dynamicContent.content.scaleIcon | translate }}
        </div>
        <ng-container *ngIf="dynamicContent.content.scaleIcon === 'numeric'">
          <div><span class="font-xl">{{ 'dynamicContent.scaleMin' | translate }}</span>: {{ dynamicContent.content.scaleMin }}</div>
          <div><span class="font-xl">{{ 'dynamicContent.scaleMax' | translate }}</span>: {{ dynamicContent.content.scaleMax }}</div>
          <div><span class="font-xl">{{ 'dynamicContent.scaleStep' | translate }}</span>: {{ dynamicContent.content.scaleStep }}</div>
        </ng-container>
        <div></div>
      </ng-container>
      <div class="font-xl">{{ 'dynamicContent.result' | translate }}</div>
      <div class="bar-chart" *ngIf="barChartOptions.series">
        <apx-chart [series]="barChartOptions.series" [chart]="barChartOptions.chart" [plotOptions]="barChartOptions.plotOptions"
                   [title]="barChartOptions.title"></apx-chart>
      </div>
    </div>
  </ng-container>
</div>
